function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_7318_383)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.33268 26.6666C4.59935 26.6666 3.97157 26.4055 3.44935 25.8833C2.92713 25.361 2.66602 24.7333 2.66602 23.9999V7.99992C2.66602 7.26659 2.92713 6.63881 3.44935 6.11659C3.97157 5.59436 4.59935 5.33325 5.33268 5.33325H11.9993V7.99992H5.33268V23.9999H26.666V7.99992H19.9993V5.33325H26.666C27.3993 5.33325 28.0271 5.59436 28.5493 6.11659C29.0716 6.63881 29.3327 7.26659 29.3327 7.99992V23.9999C29.3327 24.7333 29.0716 25.361 28.5493 25.8833C28.0271 26.4055 27.3993 26.6666 26.666 26.6666H5.33268ZM15.9993 20.5333L9.33268 13.8666L11.1993 11.9999L14.666 15.4666V5.33325H17.3327V15.4666L20.7993 11.9999L22.666 13.8666L15.9993 20.5333Z",
  fill: "#707274",
  fillOpacity: 0.9
}));

function SvgNoexports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7318_383",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoexports);
export default __webpack_public_path__ + "static/media/no exports.f1cea2ff.svg";
export { ForwardRef as ReactComponent };